/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type ContemporaryLandingCategoriesModule_contemporaryLandingRow$ref = any;
type ContemporaryLandingFeaturedModule_contemporaryLandingRow$ref = any;
type ContemporaryLandingFurnitureTileModule_contemporaryLandingRow$ref = any;
type ContemporaryLandingMakersModule_contemporaryLandingRow$ref = any;
type ContemporaryLandingProductsModule_contemporaryLandingRow$ref = any;
type ContemporaryLandingSplashHeaderModule_contemporaryLandingSplashHeader$ref = any;
type ContemporaryLandingStyleModule_contemporaryLandingRow$ref = any;
type ContemporaryLandingTextHeaderModule_contemporaryLandingHeader$ref = any;
type ContemporaryLandingVideoModule_contemporaryLandingVideo$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type ContemporaryLandingRespLayout_viewer$ref: FragmentReference;
export type ContemporaryLandingRespLayout_viewer = {|
  +contemporaryLanding: ?{|
    +modules: ?$ReadOnlyArray<?{|
      +type?: ?string,
      +$fragmentRefs: ContemporaryLandingTextHeaderModule_contemporaryLandingHeader$ref & ContemporaryLandingSplashHeaderModule_contemporaryLandingSplashHeader$ref & ContemporaryLandingStyleModule_contemporaryLandingRow$ref & ContemporaryLandingProductsModule_contemporaryLandingRow$ref & ContemporaryLandingFeaturedModule_contemporaryLandingRow$ref & ContemporaryLandingMakersModule_contemporaryLandingRow$ref & ContemporaryLandingVideoModule_contemporaryLandingVideo$ref & ContemporaryLandingCategoriesModule_contemporaryLandingRow$ref & ContemporaryLandingFurnitureTileModule_contemporaryLandingRow$ref,
    |}>
  |},
  +$refType: ContemporaryLandingRespLayout_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "kind": "Fragment",
  "name": "ContemporaryLandingRespLayout_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "contemporaryLandingPreviewId",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "contemporaryLanding",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "rootId",
          "variableName": "contemporaryLandingPreviewId",
          "type": "String"
        }
      ],
      "concreteType": "ContemporaryLanding",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "modules",
          "storageKey": null,
          "args": null,
          "concreteType": null,
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "ContemporaryLandingFeaturedModule_contemporaryLandingRow",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "ContemporaryLandingTextHeaderModule_contemporaryLandingHeader",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "ContemporaryLandingSplashHeaderModule_contemporaryLandingSplashHeader",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "ContemporaryLandingCategoriesModule_contemporaryLandingRow",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "ContemporaryLandingStyleModule_contemporaryLandingRow",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "ContemporaryLandingProductsModule_contemporaryLandingRow",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "ContemporaryLandingVideoModule_contemporaryLandingVideo",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "ContemporaryLandingMakersModule_contemporaryLandingRow",
              "args": null
            },
            {
              "kind": "InlineFragment",
              "type": "ContemporaryLandingRow",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "ContemporaryLandingFurnitureTileModule_contemporaryLandingRow",
                  "args": null
                },
                (v0/*: any*/)
              ]
            },
            {
              "kind": "InlineFragment",
              "type": "ContemporaryLandingVideo",
              "selections": (v1/*: any*/)
            },
            {
              "kind": "InlineFragment",
              "type": "ContemporaryLandingSplashHeader",
              "selections": (v1/*: any*/)
            },
            {
              "kind": "InlineFragment",
              "type": "ContemporaryLandingHeader",
              "selections": (v1/*: any*/)
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '7e69d9fc9ef5a82e6107b78323730228';
module.exports = node;
